module.exports = __webpack_public_path__ + "assets/d0fe9439c0c0a5d8944b4318b55d008f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/Multiple_Stem.mp3
 ** module id = 497
 ** module chunks = 0
 **/